import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useParams, useNavigate } from 'react-router-dom'
import { DivisionWorkspaceShell } from './workspaces'

/**
 * V2 Division Workspace — route wrapper.
 *
 * Registered standalone + auth-gated (see router.tsx):
 *   /square/command-center/workspaces/:divisionId
 *
 * The additive "organized doorway" layer: each division links to existing
 * Square Code surfaces (real routes) or shows honest PLANNED / SETUP-REQUIRED
 * placeholders. It replaces nothing and rewires no existing surface.
 */
export default function SquareCodeDivisionWorkspaceRoute() {
  const { divisionId } = useParams<{ divisionId: string }>()
  const navigate = useNavigate()
  return (
    <DivisionWorkspaceShell
      divisionId={divisionId}
      onOpenRoute={(to) => navigate(to)}
      onBack={() => navigate(COMMAND_CENTER_ROOT)}
      onOpenDivision={(id) => navigate(`${COMMAND_CENTER_ROOT}/workspaces/${id}`)}
      onHome={() => navigate(COMMAND_CENTER_ROOT)}
    />
  )
}
